const ITEMS = [
  "Resort & hotel operations",
  "Multi-site management",
  "Yield & revenue management",
  "OTA optimisation",
  "Housekeeping systems",
  "SOP & team leadership",
  "Boutique accommodation",
  "Holiday rentals",
];

export default function Credibility() {
  return (
    <section
      data-testid="credibility-marquee"
      className="relative border-y border-white/10 bg-[#080808] py-8 overflow-hidden"
    >
      <div className="flex marquee-track whitespace-nowrap">
        {[...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-12 px-12 text-xs tracking-[0.3em] uppercase text-white/40"
          >
            <span>{t}</span>
            <span className="block w-1 h-1 rounded-full bg-[#C2A878]" />
          </div>
        ))}
      </div>
    </section>
  );
}
